export default __webpack_public_path__ + "static/media/edit.932a6f90.svg";